import { useBrokerDetailsStore } from '../../../../state/brokerDetailsStore';
import { handleAdminWarning } from '../../../../../../common/SharedFunctions';

interface ValidationResult {
    isValid: boolean;
}

const _showValidationError = () => {
    handleAdminWarning('Please fill in all required fields.');
};

export const useCompanyBrandingValidation = () => {
    const validate = (): ValidationResult => {
        const brokerDetailsStore = useBrokerDetailsStore.getState();

        // Always required
        if (!brokerDetailsStore.companyLogoFile) {
            _showValidationError();
            return { isValid: false };
        }

        return { isValid: true };
    };

    return { validate };
};
